/* eslint-disable custom-eslint-rules/force-logicalOperandsMustBeBoolean */
import { CSSProperties } from "react";
import styled from "styled-components";
import { SCROLLBAR_WIDTH } from "../../default-styles/Scrollbar/Scrollbar.constants.js";
import { Flex } from "../Flex/Flex.js";
import { ITheme } from "../Theme/Theme.types.js";

export const StyledList = styled(Flex)<{ itemSpacing: keyof ITheme["spacing"] }>`
    height: 100%;
    width: 100%;
    flex: 1 1 0;

    & .list-select {
        display: flex;
        flex-direction: column;
        justify-content: center;
        opacity: 0;
        pointer-events: none;
        transition: opacity 150ms;

        &.show-selection {
            opacity: 1;
            pointer-events: all;
        }
    }

    & .list-row-content {
        display: inline-block;
        width: 100%;
    }

    & .loader {
        display: flex;
        justify-content: center;
    }

    & .item-list {
        height: 100% !important;
        overflow: unset !important;
        display: flex;
        flex-direction: column;
        gap: ${(props) => props.theme.spacing[props.itemSpacing]};
    }
`;

export const StyledListContainer = styled.div<{
    itemSpacing?: keyof ITheme["spacing"];
    overflowY?: CSSProperties["overflowY"];
}>`
    flex: 1;
    overflow-y: ${(props) => props.overflowY || "auto"};
    height: 100%;

    .infinite-scroll-component__outerdiv,
    .item-list {
        height: 100% !important;
    }

    ${(props) =>
        props.itemSpacing &&
        `
    // We don't have a better way to style react-virtuose elements
    & > div > div > div, & > div > div {
        display: flex;
        flex-direction: column;
        gap: ${props.theme.spacing[props.itemSpacing]}};
    }
    `}
`;

export const StyledListRow = styled.div<{
    hasVerticalScrollbars?: boolean;
    bgColorOnHover?: string;
    boxShadowOnRowHover?: string;
    noHover?: boolean;
}>`
    ${(props) =>
        props.hasVerticalScrollbars &&
        `
      margin-right: ${props.theme.rem(SCROLLBAR_WIDTH)};
`}
    display: flex;
    align-items: center;
    gap: ${(props) => `${props.theme.spacing[16]}`};

    &:hover .list-select:not(.hidden) {
        opacity: 1;
        pointer-events: all;
    }

    &:hover {
        border-radius: ${(props) => (props.noHover ? props.theme.radius.null : props.theme.radius.s)};
        background-color: ${(props) => (props.noHover ? "none" : props.bgColorOnHover)};
        box-shadow: ${(props) => (props.noHover ? "none" : props.boxShadowOnRowHover)};
    }
`;
